export default __webpack_public_path__ + "static/media/male-icon.b46efac7.svg";